import { forwardRef } from '../../../../utils';
import { useMultiStyleConfig } from '../../../../utils/use-style-config';
import { Typography } from '../../../dataDisplay';
import { Box } from '../../Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Section = forwardRef((_ref, ref) => {
  var {
    onHover,
    label,
    isVerified,
    children
  } = _ref;
  var styles = useMultiStyleConfig('BaseSelect', {});
  return /*#__PURE__*/_jsxs(Box, {
    "data-component": "BaseSelect.Section",
    ref: ref,
    onMouseOver: onHover,
    children: [/*#__PURE__*/_jsx(Box, {
      __css: styles['sectionLabel'],
      children: /*#__PURE__*/_jsx(Typography.SectionLabel, {
        label: label,
        isVerified: isVerified,
        tooltipProps: undefined
      })
    }), /*#__PURE__*/_jsx(Box, {
      children: children
    })]
  });
});
Section.displayName = 'BaseSelect.Section';
//# sourceMappingURL=Section.js.map